<div *ngIf="!hideSpinner" class="spinner-container">
  <div class="spinner-block">
    <mat-spinner mode="indeterminate" diameter="50"></mat-spinner>
  </div>
  <span>Loading data...</span>
</div>
